import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';

import { StyledWrapper, StyledImageWrapper, StyledTextWrapper, StyledHeader, StyledButton } from './CollectionsBillboardStyles';

var CollectionsBillboard = function CollectionsBillboard(_ref) {
  var itemsToDisplay = _ref.itemsToDisplay,
      collectionsBillboard = _ref.collectionsBillboard;
  var row = collectionsBillboard.row,
      col = collectionsBillboard.col,
      bgImg = collectionsBillboard.bgImg,
      caption = collectionsBillboard.caption,
      btnText = collectionsBillboard.btnText,
      btnUrl = collectionsBillboard.btnUrl;


  var numOfItems = itemsToDisplay.length ? itemsToDisplay.length : 0;
  var numOfCols = 3;
  var billboardIndex = parseInt(row) * numOfCols + (parseInt(col) - numOfCols - 1);

  // Set grid-row and grid-col only if
  // billboard's index/position is less than or equal to
  // the number of items.
  var positionRowOnGrid = numOfItems >= billboardIndex;
  return React.createElement(
    StyledWrapper,
    { row: row, col: col, positionRowOnGrid: positionRowOnGrid },
    React.createElement(
      StyledImageWrapper,
      null,
      React.createElement(Image, { src: bgImg, alt: caption })
    ),
    React.createElement(
      StyledTextWrapper,
      null,
      React.createElement(
        StyledHeader,
        null,
        caption
      ),
      React.createElement(
        StyledButton,
        { href: btnUrl },
        btnText
      )
    )
  );
};

export default CollectionsBillboard;

CollectionsBillboard.propTypes = {
  itemsToDisplay: PropTypes.array.isRequired,
  collectionsBillboard: PropTypes.object.isRequired
};